import './styles.scss';

import React, {PropsWithChildren} from 'react';

interface IAppModalProps extends PropsWithChildren {
    className?: string;
    containerClassName?:string;
    onClose?: () => void;
    hideCloseButton?: boolean;
}

export const AppModal = ({className = '', containerClassName = '', onClose, children, hideCloseButton = false}: IAppModalProps) => {
    return (
        <div className={`app-modal ${className}`}>
            <div className={`app-modal__container ${containerClassName}`}>
                {onClose && !hideCloseButton && <span className='app-modal__close' onClick={onClose}></span>}
                <div className='app-modal__content'>{children}</div>
            </div>
        </div>
    );
};
